import { Component, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { BaseControlValueAccessor } from '../../form-fields/base_control_value_accessor/base';

@Component({
  selector: 'app-remarks',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => RemarksComponent),
    }
  ]
})
export class RemarksComponent extends BaseControlValueAccessor implements OnInit {
  location_url = ApiRoutes.Location;

  @Input()
  showIcon: boolean = false;

  @Input()
  commentDate;

  @Input()
  headLabel: boolean = true;

  @Input()
  updatedBy;

  @Input()
  companyName: string;

  @Input()
  createdBy;

  @Input()
  createdAt;

  @Input()
  forCustomerMaster: boolean = false;

  constructor() {
    super();
  }

  ngOnInit() {
  }
}
